export default __webpack_public_path__ + "static/media/emoji.424df5d5.svg";